import type { ThemedValue, ThemeMode } from '@creditornot/cb-utils';

export function readThemedValue(
  value: string | ThemedValue,
  themeMode: ThemeMode,
  elevated?: boolean,
): string {
  if (typeof value === 'string') return value;

  if (themeMode === 'dark' && typeof value.dark === 'object') {
    return elevated ? value.dark.elevated : value.dark.default;
  }

  if (themeMode === 'dark' && typeof value.dark === 'string') {
    return value.dark;
  }

  if (themeMode === 'lightHighContrast') {
    return value.lightHighContrast ?? value.light;
  }

  if (themeMode === 'light') {
    return value.light;
  }

  throw new Error(`Invalid theme value: ${JSON.stringify(value)}`);
}
